import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,_vm._b({model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},'v-snackbar',_vm.options,false),[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c(VBtn,{attrs:{"dark":"","text":""},on:{"click":function($event){_vm.visible = false}}},[_vm._v("\n    Close\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }